import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    companies: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_COMPANY_SELECT_IDS (store, ids) {
      store.companies.selectIds = ids
    },
    REMOVE_COMPANY_SELECT_IDS (store, ids) {
      store.companies.selectIds = store.companies.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_COMPANY_SELECT_ID (store, id) {
      store.companies.selectId = id
    },
    SET_COMPANY_FILTERS (store, filters) {
      store.companies.filters = filters
    },
    SET_COMPANY_PAGINATE (store, val) {
      store.companies.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getCompanies: (store, getters) => {
      return store.companies.selectIds.map((id) => {
        return getters['entities/companies/find'](id)
      })
    },
    getCompaniesFilters: (store, getters) => {
      return store.companies.filters
    },
    getCompaniesPaginate: (store, getters) => {
      return store.companies.paginate
    },
    getCompany: (store, getters) => {
      return getters['entities/companies/find'](store.companies.selectId) || {}
    }
  },
  actions: {
    /*
    selectCompanies
    */
    selectCompanies ({commit, dispatch, getters, state}, filters) {
      return dispatch('getCompanies', filters)
      .then((response) => {
        commit('SET_COMPANY_FILTERS', filters)
        commit('SET_COMPANY_PAGINATE', response)
        commit('SET_COMPANY_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectCompanies
    */
    refreshSelectCompanies ({commit, dispatch, getters, state}) {
      return dispatch('selectCompanies', getters.getCompaniesFilters)
    },
    /*
    selectCompany
    */
    selectCompany ({commit, dispatch, getters, state}, id) {
      return dispatch('getCompanyById', id)
      .then((response) => {
        commit('SET_COMPANY_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getCompanies
    */
    getCompanies ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/companies`, {params: filters})
      .then((response) => {
        return dispatch('entities/companies/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.companies || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getCompanyById
    */
    getCompanyById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/companies/${id}`)
      .then((response) => {
        return dispatch('entities/companies/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.companies[0]
      })
    },
    /*
    createCompany
    */
    createCompany ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/companies`, data)
      .then((response) => {
        return dispatch('entities/companies/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.companies[0]
      })
    },
    /*
    updateCompany
    */
    updateCompany ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/companies/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/companies/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.companies[0]
      })
    },
    /*
    mergeCompanies
    */
    mergeCompanies ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/companies/merge`, data)
      .then((response) => {
        return dispatch('entities/companies/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.companies[0]
      })
    },
    /*
    deleteCompany
    */
    deleteCompany ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/companies/${id}`)
      .then((response) => {
        commit('REMOVE_COMPANY_SELECT_IDS', [id])
        dispatch('entities/companies/delete', id)
        return {}
      })
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/Company.js